import * as Button from './../../components/Atoms/Button';
import * as Modal from './../../components/Atoms/Modal';

import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import _ from 'lodash';
import { CommonUtil } from '../../utils/commonUtil';

const convertWonSymbol = (text = '') =>
  String(text).replace(/\\(?=\s*\d)/g, '₩');

const Counseling = ({
  consultationList,
  registerConsultation,
  changeConsultation,
  NEW,
  consultationTotal = 0,
  consultationPage = 1,
  consultationSize = 10,
  onConsultationPageChange,
  viewOnly = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({
    type: '',
    content: '',
  });
  const [selectedContent, setSelectedContent] = useState({
    dataId: 0,
    consultationGroupId: '',
    note: '',
    useYN: '',
    regTime: '',
    regBy: 0,
    modTime: null,
    modBy: null,
    delTime: null,
    delBy: null,
  });
  const [list, setList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [allText, setAllText] = useState('');
  const consultationFirst = (consultationPage - 1) * consultationSize;
  const splitPanelHeight = 'calc(100vh - 12rem)';

  useEffect(() => {
    if (consultationList) {
      setList(consultationList);
    }
  }, [consultationList]);

  useEffect(() => {
    if (list) {
      const arr = [];
      list.map((el) =>
        arr.push(
          `[생성일시 : ${el.regTime.replace('T', ' ')}] \n${convertWonSymbol(
            el.note
          )}`
        )
      );
      setAllText(arr.join('\n\n'));
    }
  }, [list]);

  useEffect(() => {
    if (!showList) {
      sessionStorage.clear();
    }
  }, [showList]);

  const initSelectedContent = () => {
    setSelectedContent({
      dataId: 0,
      consultationGroupId: '',
      note: '',
      useYN: '',
      regTime: '',
      regBy: 0,
      modTime: null,
      modBy: null,
      delTime: null,
      delBy: null,
    });
  };

  return (
    <>
      <Panel
        header={
          <div className="flex justify-content-between align-items-center">
            <div>상담 이력</div>
            {!!list.length && (
              <Button.Default
                icon="pi pi-external-link"
                type="button"
                className="p-button-help p-button-outlined p-button-sm"
                label="상담 이력 전체보기"
                onClick={() => {
                  setShowList(true);
                  sessionStorage.setItem('data', JSON.stringify(allText));
                  CommonUtil.Window.popup(
                    '/compensation/accident/claim/detail/counseling',
                    '',
                    '600px',
                    window.innerHeight * 0.8
                  );
                }}
              />
            )}
          </div>
        }
        id="note"
        className="mb-0"
      >
        <div
          className="flex flex-column"
          style={{ height: splitPanelHeight, minHeight: '34rem' }}
        >
          <div
            className="flex flex-column min-h-0"
            style={{ height: '50%', overflow: 'hidden' }}
          >
            <div className="flex-1 min-h-0">
              <DataTable
                emptyMessage="이력이 없습니다."
                value={list}
                responsiveLayout="scroll"
                showGridlines
                stripedRows
                selectionMode="single"
                scrollable
                scrollHeight="flex"
                onRowClick={(e) => {
                  setSelectedContent(e.data);
                }}
              >
                <Column
                  field="dtn"
                  align={'center'}
                  headerStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  style={{
                    maxWidth: '4rem',
                  }}
                  header="순번"
                  body={(id, column) => (
                    <span>{consultationFirst + column.rowIndex + 1}</span>
                  )}
                />
                <Column
                  field="regTime"
                  header="생성일시"
                  align={'center'}
                  headerStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  style={{
                    maxWidth: '8rem',
                  }}
                  body={({ regTime }) => (
                    <span>{regTime.replace('T', '\r\n')}</span>
                  )}
                />
                <Column
                  field="note"
                  header="내용"
                  headerStyle={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  className="w-full overflow-hidden"
                  body={({ note }) => {
                    return (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: convertWonSymbol(note).replaceAll(
                            '\n',
                            '<br />'
                          ),
                        }}
                      ></div>
                    );
                  }}
                />
              </DataTable>
            </div>
            <div className="mt-2 flex justify-content-end">
              <Paginator
                first={consultationFirst}
                rows={consultationSize}
                totalRecords={consultationTotal}
                rowsPerPageOptions={[10, 20, 50]}
                onPageChange={(e) => {
                  if (!onConsultationPageChange) return;
                  onConsultationPageChange(e.page + 1, e.rows);
                }}
              />
            </div>
          </div>

          <div
            className="mt-1 border-1 border-200 border-round surface-ground"
            style={{ height: '50%', overflow: 'auto' }}
          >
            <div className="h-full flex flex-column">
              <div
                className="flex justify-content-between align-items-center"
                style={{ padding: '10px' }}
              >
                <span className="font-semibold text-lg" style={{ lineHeight: 1 }}>
                  {_.get(selectedContent, 'note') !== ''
                    ? '상세 보기'
                    : '상담 작성'}
                </span>
                {_.get(selectedContent, 'note') !== '' ? (
                  <div className="flex gap-2">
                    <Button.Default
                      type="button"
                      label="뒤로 가기"
                      className="p-button-outlined"
                      icon="pi pi-arrow-left"
                      onClick={() => {
                        initSelectedContent();
                      }}
                    />
                  </div>
                ) : (
                  !viewOnly && (
                  <Button.Default
                    type="button"
                    label="저장"
                    className="p-button-lg"
                    onClick={() => {
                      registerConsultation(convertWonSymbol(data.content));
                      setData({ ...data, content: '' });
                    }}
                    disabled={data.content === '' || NEW}
                  />
                  )
                )}
              </div>
              {_.get(selectedContent, 'note') !== '' ? (
                <>
                  <div
                    className="flex align-items-center"
                    style={{ paddingLeft: '10px', paddingBottom: '10px' }}
                  >
                    <div style={{ flex: '1 1 auto', marginRight: '10px' }}>
                      <div className="p-inputgroup flex align-items-center">
                        <label htmlFor="" className="mr-2 font-semibold w-4rem">
                          생성일시
                        </label>
                        <InputText
                          value={_.get(selectedContent, 'regTime').replace(
                            'T',
                            ' '
                          )}
                          readOnly
                        />
                      </div>
                    </div>
                    {!viewOnly && (
                    <div className="flex justify-content-end align-items-center gap-2">
                      <Button.Default
                        type="button"
                        className="p-button-outlined p-button-sm"
                        style={{
                          height: '2rem',
                          padding: '0 0.75rem',
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                        label="수정"
                        onClick={() => {
                          changeConsultation(
                            selectedContent.dataId,
                            convertWonSymbol(selectedContent.note),
                            'Y'
                          );
                        }}
                      />
                      <Button.Default
                        type="button"
                        label="삭제"
                        className="p-button-outlined p-button-danger p-button-sm"
                        style={{
                          height: '2rem',
                          padding: '0 0.75rem',
                          marginRight: '10px',
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                        onClick={() => {
                          setShowModal(true);
                        }}
                      />
                    </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="col-3">
                  <div className="p-inputgroup flex align-items-center"></div>
                </div>
              )}
              <div
                className="flex-1"
                style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: '10px' }}
              >
                <div
                  className="h-full"
                  style={{ minHeight: '16rem' }}
                >
                  <InputTextarea
                    placeholder={
                      NEW
                        ? '클레임 저장 후 상담 작성이 가능합니다.'
                        : viewOnly
                        ? '조회 전용 계정입니다.'
                        : ''
                    }
                    value={
                      selectedContent.note
                        ? convertWonSymbol(selectedContent.note)
                        : convertWonSymbol(data.content)
                    }
                    onChange={(e) => {
                      if (viewOnly) return;
                      const normalizedValue = convertWonSymbol(e.target.value);
                      selectedContent.note
                        ? setSelectedContent({
                            ...selectedContent,
                            note: normalizedValue,
                          })
                        : setData((ps) => ({
                            ...ps,
                            content: normalizedValue,
                          }));
                    }}
                    className="w-full h-full"
                    style={{ width: '100%', marginLeft: 0, display: 'block' }}
                    readOnly={viewOnly}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>

      {showModal && (
        <Modal.Default
          onHide={() => setShowModal(!showModal)}
          header={'상담이력 삭제'}
          widthClass="30rem"
        >
          <div className="pb-4">해당 상담이력을 삭제하시겠습니까?</div>
          <div className="flex gap-4 justify-content-center	">
            <Button.Default
              label="삭제"
              className="p-button-outlined p-button-danger"
              onClick={() => {
                changeConsultation(
                  selectedContent.dataId,
                  selectedContent.note,
                  'N'
                );
                initSelectedContent();
                setShowModal(false);
              }}
            />
            <Button.Default
              label="취소"
              className="p-button-outlined"
              onClick={() => setShowModal(false)}
            />
          </div>
        </Modal.Default>
      )}
    </>
  );
};

export default Counseling;
